import { useMutation } from '@tanstack/react-query';

import { type MyPosPaymentProvider } from 'src/features/parkingManagement/api/paymentPaymentProviders/useGetMyPOSPaymentProvider';
import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query.ts';
import { formatResourcePath } from 'src/utils/regex.ts';

import type { GeneralSmartParkError } from 'src/types/errors';

interface DTO {
    parkingId: string;
    id: string;
    public_certificate?: File;
    private_key?: File;
    store_id?: string;
    client_number?: string;
    key_index?: number;
}
const RESOURCE = '/parkings/:parkingId/mypos-payment-provider/:id/';

type MutationFnType = typeof mutationFn;
const mutationFn = ({ parkingId, id, ...data }: DTO): Promise<MyPosPaymentProvider> => {
    const formData = new FormData();

    Object.entries(data).forEach(([key, value]) => {
        if (value === undefined || value === null) return;

        if (value instanceof Blob) {
            formData.append(key, value);
        } else {
            formData.append(key, String(value));
        }
    });

    return axios.patch(formatResourcePath(RESOURCE, { parkingId, id }), formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

interface UseMutationOptions extends MutationConfig<MutationFnType, GeneralSmartParkError> {}
const useMutationHook = (options: UseMutationOptions = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateMyPosPaymentProvider };
export type { DTO as UpdateMyPosPaymentProviderType };
